<script setup lang="ts">
import Curtains from '@/shared/components/core/Curtains/Curtains.vue';
import PromoVideo from '@/shared/components/core/PresentaitonPromo/PromoVideo.vue';
import { usePresentationPromoStore } from '@/shared/components/core/PresentaitonPromo/store.ts';
import { usePresentationMode } from '@/shared/components/core/PresentaitonPromo/usePresentationMode.ts';
import { useMainStore } from '@/core/store/main.ts';
import { MaybeNull } from '@/shared/types';
import { storeToRefs } from 'pinia';
import {
  computed,
  onMounted,
  Ref,
  ref,
} from 'vue';
import { useRoute } from 'vue-router';

const { mode } = storeToRefs(useMainStore());
const { onStopCallback } = storeToRefs(usePresentationPromoStore());

const curtains$: Ref<MaybeNull<typeof Curtains>> = ref(null);
const promoVideo$: Ref<MaybeNull<typeof PromoVideo>> = ref(null);

const route = useRoute();

onMounted(() => {
  if (route.query.mode) {
    mode.value = route.query.mode as string;

    localStorage.setItem('mode', mode.value);
  } else {
    mode.value = localStorage.getItem('mode') as string;
  }
});

const { promoVideoEnabled, curtainsEnabled } = usePresentationMode({
  closeCurtains: computed(() => curtains$.value?.closeCurtains),
  openCurtains: computed(() => curtains$.value?.openCurtains),

  playVideo: computed(() => promoVideo$.value?.openVideo),
  stopVideo: computed(() => promoVideo$.value?.closeVideo),

  onStop: onStopCallback.value,
});

</script>

<template>
  <div
    class="presentation-component"
    :class="{'disable-presentation': !curtainsEnabled}"
  >
    <Curtains
      ref="curtains$"
    />

    <PromoVideo
      ref="promoVideo$"
      :active="promoVideoEnabled"
      :video="{
        url: 'https://assets.dev.ohmy.bible/uploads/exodus_c14/demo.mp4',
      }"
    />
  </div>
</template>

<style scoped>
.presentation-component {
  position: relative;
  width: 100%;
  height: 100%;
}

.disable-presentation {
  display: none;
}
</style>
